/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsBuild {
    getFixupPrototypeFunction() { return AzureDevOpsBuild.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsBuild>): AzureDevOpsBuild {
        let obj = Object.assign(new AzureDevOpsBuild(), model);
        AzureDevOpsBuild.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsBuild>): AzureDevOpsBuild {
        if (!model) return null;
        return AzureDevOpsBuild.newInstance(<AzureDevOpsBuild> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsBuild) {
        if (!obj) return;

        models.AzureDevOpsBuild.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsBuild): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsBuild.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.build_id === undefined) {
            this.build_id = 0;
        }
        if (typeof this.started === "string") {
            this.started = new Date(<string><any>this.started);
        }
        if (typeof this.finished === "string") {
            this.finished = new Date(<string><any>this.finished);
        }
    }

    build_id: number;

    /**
     * Name of the Build
     */
    name: string;

    /**
     * Build Status
     */
    status: models.AzureDevOpsPipelineBuildStatus;

    /**
     * Build Result
     */
    result: models.AzureDevOpsPipelineBuildResult;

    started: Date;

    finished: Date;

    /**
     * Branch of the repo under Build
     */
    branch: string;

    /**
     * Version of the repo under Build
     */
    version: string;

}
